export default __webpack_public_path__ + "static/network13-840c12908b86d37e22adb34df3591c9c.png";